"use client";

import { useEffect, useContext, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";

const LogoutContent = () => {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // نمایش کوتاه‌مدت اطلاعات کاربر و سپس خروج کامل
    const timer = setTimeout(() => {
      logout(); // از AuthContext استفاده می‌کنیم
      setLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, [logout]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
        <p className="mt-3">در حال خروج از حساب...</p>
      </div>
    );
  }

  return (
    <div className="auth-main-content m-auto m-1230 px-3">
      <Row className="align-items-center">
        <Col lg={6} className="d-none d-lg-block">
          <img
            src="/images/login.jpg"
            className="rounded-3"
            alt="login"
            width={646}
            height={804}
          />
        </Col>

        <Col lg={6}>
          <div className="mw-480 ms-lg-auto">
            {/* ✅ لوگو */}
            <div className="d-inline-block mb-4">
              <img
                src="/images/logo.svg"
                className="rounded-3 for-light-logo"
                alt="logo"
                width={100}
                height={26}
              />
              <img
                src="/images/white-logo.svg"
                className="rounded-3 for-dark-logo"
                alt="logo"
                width={100}
                height={26}
              />
            </div>

            {/* ✅ پیام خروج */}
            <h3 className="fs-28 mb-2">شما خارج شدید!</h3>
            <p className="fw-medium fs-16 mb-4">
              {user?.mobile
                ? `کاربر ${user.mobile} از حساب کاربری خارج شد.`
                : "از حساب کاربری خارج شدید."}
            </p>

            {/* ✅ اطلاعات کاربر (در صورت وجود) */}
            {user && (
              <div className="d-flex align-items-center gap-2 mb-3">
                <div>
                  <img
                    src="/images/user-69.jpg"
                    alt="user"
                    width={50}
                    height={50}
                    style={{ borderRadius: "100px" }}
                  />
                </div>
                <h5 className="m-0 fs-16">
                  {user.mobile || "کاربر"}
                </h5>
              </div>
            )}

            {/* ✅ لینک ورود مجدد */}
            <Link
              to="/authentication/sign-in"
              className="btn btn-primary fw-medium py-2 px-3 w-100"
            >
              <div className="d-flex align-items-center justify-content-center py-1">
                <span className="material-symbols-outlined fs-20 text-white me-2">
                  login
                </span>
                <span>ورود مجدد</span>
              </div>
            </Link>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LogoutContent;
